import { apiUrlImg } from "../../Routes/api/global_vars";

const ServiceCard = ({ image, nom_service, sous_services }) => {
  return (
    <div className="flex flex-col max-md:p-4 max-md:mb-4 py-10 px-3 !m-4 card bg-white rounded-lg shadow-md hover:scale-105 transition-transform duration-300">
      <div className="flex flex-col items-center md:mb-2 m-0">
        <div className="flex justify-center items-center rounded-full pb-2">
          <img
            src={`${apiUrlImg}/${image}`}
            alt={`${nom_service} icon`}
            className="w-12 h-12"
          />
        </div>
        <h1
          style={{ color: "#1F2937" }}
          className="font-semibold text-center text-[#1F2937] md:text-[20px] weight-[500] ml-2"
        >
          {nom_service}
        </h1>
      </div>
      <div>
        <ul
          className={`list-disc text-xs text-grayrel pt-2 flex items-center justify-center flex-wrap gap-3`}
        >
          <li className="text-xs text-graybadge list-none">
            {sous_services?.map((item) => item?.nom_sous_service).join(", ")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ServiceCard;